class EntityDef(
    val id: String,
    val type: String,
    val col: Int,
    val row: Int,
    val width: Int = 1,
    val height: Int = 1,
    val params: String = "",
    val tag: String = "",
    val reset: Boolean = false
) {
}
